import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, path, image, type = "website", jsonLd }) => {
  const ld = JSON.stringify(jsonLd);

  useEffect(() => {
    const origin = process.env.REACT_APP_SITE_URL;
    const url = `${origin}${path}`;
    const img = image ? `${origin}${image}` : undefined;

    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:site_name", "erth. escapes");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    if (img) setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (img) setMeta("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-testid", "seo-jsonld");
    script.text = ld.replaceAll("__ORIGIN__", origin);
    document.head.appendChild(script);
    return () => script.remove();
  }, [title, description, path, image, type, ld]);
};
